<div id="page-login"
    class="site-wrapper">
    <main class="main">
        <div class="page-wrapper">
            <div class="page-content lean">
                <a routerLink="/">
                    <img class="logo"
                        src="/assets/images/logo/logo-teamworks-primary_white.svg"
                        alt="" />
                </a>

                <form [formGroup]="forgotPasswordForm"
                    class="login-form"
                    (ngSubmit)="onSubmit()">
                    <mat-form-field class="minimal">
                        <mat-label>{{ 'FORGOT_PASSWORD.EMAIL_PLACEHOLDER' | translate}}</mat-label>
                        <input matInput
                            type="email"
                            formControlName="email"
                            required>
                        <mat-error *ngIf="forgotPasswordForm.controls.email.hasError('required')"
                            [innerHTML]="'LOGIN.EMAIL_REQUIRED' | translate">
                        </mat-error>
                        <mat-error *ngIf="forgotPasswordForm.controls.email.hasError('email')"
                            [innerHTML]="'LOGIN.EMAIL_ERROR' | translate">
                        </mat-error>
                    </mat-form-field>

                    <button class="btn-login oa-button"
                        type="submit"
                        [class.loading]="isChangingPassword$ | async"
                        [disabled]="!forgotPasswordForm.valid">{{ 'FORGOT_PASSWORD.CHANGE_PASSWORD_BUTTON' | translate }}</button>
                </form>

                <div *ngIf="!(tokenExpiredError$ | async)"
                    class="error-container">
                    <p class="form-message {{(authStatusMessage$ | async)?.type === 'success' ? 'form-success' : 'form-error'}}">
                        {{(authStatusMessage$ | async)?.message}}
                    </p>
                </div>

                <div class="error-container"
                    *ngIf="(tokenExpiredError$ | async) as tokenExpiredError">
                    <p class="form-message form-error">
                        {{tokenExpiredError.message}}
                    </p>
                </div>
            </div>
        </div>
    </main>
</div>
